'use client';
import React, { useState } from 'react';
import classes from '../styles.module.scss';
import { Control, useController, useFormContext } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';

const TextFieldFormControlled = ({
    name,
    control,
    leadingText,
    numeric,
    placeholder,
    type = 'text',
    inputMode = 'text',
}: {
    name: string;
    control: Control;
    leadingText?: string;
    numeric?: boolean;
    placeholder?: string;
    type?: 'text' | 'number' | 'phone' | 'email';
    inputMode?: 'text' | 'numeric' | 'decimal';
}) => {
    const { field } = useController({ name, control });

    const [focus, setFocus] = useState<boolean>(false);
    const {
        formState: { errors },
    } = useFormContext();
    const { t } = useTranslation();
    return (
        <div className={classes.input_container}>
            <Typography variant={'body2Medium'} className={classes.input_label}>
                {leadingText}
            </Typography>
            {numeric ? (
                <NumericFormat
                    allowLeadingZeros={false}
                    allowNegative={false}
                    {...field}
                    className={classes.input}
                    style={{
                        borderColor: errors[name] ? '#FDA29B' : '#d0d5dd',
                    }}
                    valueIsNumericString={true}
                    thousandSeparator={true}
                />
            ) : (
                <input
                    {...field}
                    type={type}
                    inputMode={inputMode}
                    className={`${classes.input}  ${
                        focus ? 'border-primary-300 ' : 'border-gray-300 '
                    }`}
                    ref={e => {
                        field.ref(e);
                    }}
                    placeholder={placeholder}
                    style={
                        focus
                            ? {
                                  borderColor: errors[name]
                                      ? '#FDA29B'
                                      : '#d0d5dd',
                                  paddingInline: leadingText ? '46px' : '12px',
                                  boxShadow:
                                      '0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #E6FBF2',
                                  outlineColor: 'rgb(102 226 176)',
                              }
                            : {
                                  borderColor: errors[name]
                                      ? '#FDA29B'
                                      : '#d0d5dd',
                                  paddingInline: leadingText ? '46px' : '12px',
                              }
                    }
                    onFocus={() => {
                        setFocus(true);
                    }}
                    onBlur={() => {
                        setFocus(false);
                    }}
                />
            )}

            {errors[name]?.message && (
                <span className={classes.input_error}>
                    {t(errors[name]?.message as string) || ''}
                </span>
            )}
        </div>
    );
};
export default TextFieldFormControlled;
